import React from 'react'
import { Confirm, Message, Transition } from 'semantic-ui-react';
import ButtonsAttached from './ButtonsAttached';

/* Props includes
  modeltypes
  modeltype (the current active modeltype)
  onChange (updateModelType from JFrom)
*/

// CSS Fix
const inlineStyle = {
  confirm : {
    position: 'fixed',
    top: '25%',
    left: '20%'
  }
};

class ModelSelect extends React.Component {
  // State
  state = {open: false,
           proposedType: null}
  
  // Bindings
  open = this.open.bind(this);
  close = this.close.bind(this);
  updateModelType = this.updateModelType.bind(this);
  
  // Functions
  close() {this.setState({open : false})}
  
  open(e,d) {
    // Only show confirm if model type is being changed
    if (this.props.modeltype === d.value) {
      // No Change, Do Nada
    }
    else if (this.props.modeltype !== undefined) {
      this.setState({proposedType : d.value,
                     open : true})
    } else {
      this.props.onChange(e,d);
    }
  }

  updateModelType(e) {
    const d = {};
    d.value = this.state.proposedType;
    this.props.onChange(e,d);
    this.close();
  }

  render() {
    const {modeltypes, modeltype} = this.props;
    const meukWarn = modeltype === 'MEUK' ? true : false;

    return(
      <div>
        <Confirm open={this.state.open}
                 header="Confirm Model Type Change"
                 content="Changing the Flow Model Type will clear the Model Settings. Proceed?"
                 onCancel={this.close}
                 onConfirm={this.updateModelType}
                 style={inlineStyle.confirm} />
        
        <ButtonsAttached labels={modeltypes} values={modeltypes} active={modeltype} onClick={this.open}/>

        <Transition visible={meukWarn} animation='drop' duration={500} className='flex'>
          <Message negative hidden={!meukWarn}
                   header="MEUK support is still under development"
                   content="Currently only MODFLOW Model Settings can be generated." />
        </Transition>
      
      </div>
    );
  }
}

export default ModelSelect;